import { instance } from './index';

//get advertiser list
function advertiserList() {
  return instance.get('api/advertisers');
}

//create advertiser
function createAdvertiser(data) {
  return instance.post('api/advertisers', data);
}

//get advertiser detail
function detailAdvertiser(id) {
  return instance.get(`api/advertisers/${id}`);
}

//edit advertiser info
function updateAdvertiser(id, data) {
  return instance.put(`api/advertisers/${id}`, data);
}

//해당 광고주가 진행하고 있는 캠페인 목록
function hasCampignAdvertiser(id) {
  return instance.get(`api/advertisers/${id}/campaigns`);
}

//해당광고주가 이전에 사용한 소재의 목록
function resourcesHistoryToAdviertiser(advertiserId, inventoryId) {
  return instance.get(
    `api/advertisers/${advertiserId}/inventories/${inventoryId}/resources`,
  );
}

export {
  advertiserList,
  createAdvertiser,
  detailAdvertiser,
  updateAdvertiser,
  hasCampignAdvertiser,
  resourcesHistoryToAdviertiser,
};
